export default {
  RETIREMENT_GOAL_MONTHLY_PAYMENT_CALCULATION_REPOSITORY: Symbol.for('RETIREMENT_GOAL_MONTHLY_PAYMENT_CALCULATION_REPOSITORY'),
  CALCULATE_RETIREMENT_GOAL_MONTHLY_PAYMENT_CALCULATION_QUERY: Symbol.for('CALCULATE_RETIREMENT_GOAL_MONTHLY_PAYMENT_CALCULATION_QUERY'),
  RETIREMENT_GOAL_MONTHLY_PENSION_ADJUSTED_CALCULATION_REPOSITORY: Symbol.for('RETIREMENT_GOAL_MONTHLY_PENSION_ADJUSTED_CALCULATION_REPOSITORY'),
  CALCULATE_RETIREMENT_GOAL_MONTHLY_PENSION_ADJUSTED_CALCULATION_QUERY: Symbol.for('CALCULATE_RETIREMENT_GOAL_MONTHLY_PENSION_ADJUSTED_CALCULATION_QUERY'),
};
